module.exports = __webpack_public_path__ + "img/mobile.615244c6.png";